import React, { useState, useEffect, useCallback} from 'react';
import Loader from './components/UI/Loader/Loader';
import moment from 'moment';
import axios from './axios-instance';
import ContentDetails from './components/ContentDetails/ContentDetails';
import actv8Logo from './images/actv8me-logo.png';
import Button from './components/UI/Button/Button';
import scratchImage from './images/swipe-to-reveal-v2.png';
import { useSelector, useDispatch } from 'react-redux';
import {
    setAndroidPassDetails,
    setContentItem,
    setContentResponse,
    setTerms,
} from './store/contentSlice';
import Footer from './components/UI/Footer/Footer';
import { updateContentStatus, postEvent, getCdnPath} from './utils/helpers';

const Content = (props) => {
    const {
        loading,
        showActv8,
        setShowActv8,
        forwardParams,
        device,
        hasSlug,
        location,
        catchUrlSearch,
        setShowError,
        setLoading,
        timestamp
    } = props;
    const [showScratcherOverlay, setShowScratcherOverlay] = useState(null);
    const [scratcherOverlayImage, setScratcherOverlayImage] = useState(null);

    const dispatch = useDispatch();
    const content = useSelector((state) => state.content);
    const [deliveredContent, setDeliveredContent] = useState(null);
    const [deliveredContentCursor, setDeliveredContentCursor] = useState(0);
    const [triggerUuid, setTriggerUuid] = useState(null);

    const onRedirectUrl = (url) => {
        let newUrl;
        newUrl = url.replace('?a8_redirect=1', '');
        newUrl = newUrl.replace('?a8_redirect=0', '');
        newUrl = newUrl.replace('&a8_redirect=1', '');
        newUrl = newUrl.replace('&a8_redirect=0', '');
        console.log(encodeURIComponent(newUrl));
        window.location.href = newUrl;
        setTimeout(() => {
            window.open('/redirect?url=' + newUrl, '_self'); 
        }, 5000)
        
    };

    const checkScratcher = useCallback((data) => {
        if (data?.scratcher?.enabled) {
            let scratcherImage = data?.scratcher?.images?.overlay?.url
                ? getCdnPath(data.scratcher.images.overlay.url)
                : scratchImage;
            //let scratcherImage = data.scratcher.images && data.scratcher.images.overlay && data.scratcher.images.overlay.url ? data.scratcher.images.overlay.url : scratchImage;
            setShowScratcherOverlay(true);
            setScratcherOverlayImage(scratcherImage);
        } else {
            setShowScratcherOverlay(false);
        }
    }, []);


    const getContentTerms = useCallback(
        async (id, device) => {
            try {
                let res = await axios.get(`content-terms/` + id, {
                    headers: {
                        'x-device-uuid': `${device?.uuid}`,
                    },
                });
                if (res) {
                    let terms = String(res.data.body);
                    dispatch(setTerms(terms));
                }
            } catch (err) {
                console.log('Error: ', err);
            }
        },
        [dispatch]
    );

    const postAndroidPass = useCallback(
        async (id, device) => {
            try {
                const res = await axios.post(
                    `/device/${device?.id}/content/${id}/androidpass`,
                    {
                        forward_url_params: forwardParams,
                    },
                    {
                        headers: {
                            'x-device-uuid': `${device?.uuid}`,
                        },
                    }
                );
                if (res) {
                    dispatch(
                        setAndroidPassDetails({
                            androidPass: true,
                            jwt: res.data.jwt.jwt,
                        })
                    );
                    setLoading(false);
                }
            } catch (err) {
                console.log('Error :', err);
                setLoading(false);
            }
        },
        [dispatch, forwardParams, setLoading]
    );

    const onSetContentItem = useCallback(
        (content, device) => {
            if(!content) {
                return;
            }

            let end;
            let isBuyInStore;
            let tandc = 'Terms & Conditions';
            let exp = 'Expired';
            let termID = content?.content_term_id;
            let showDownload = false;
            let buyNowText = 'Buy Now';
            let buyInStoreText = 'Buy In-Store';
            let clickThroughBtnOne;
            let clickThroughBtnTwo;

            if (content?.buttons?.length > 0) {
                const buttons = content.buttons.slice();
                const buyNowButtons = buttons.filter(
                    (button) =>
                        button.key === 'redeem_online_btn' &&
                        button.locale === 'en'
                );
                const buyInStoreButton = buttons.filter(
                    (button) =>
                        button.key === 'redeem_in_store_btn' &&
                        button.locale === 'en'
                );
                const clickThroughBtn1 = buttons.filter(
                    (button) =>
                        button.key === 'click_through_btn_1' &&
                        button.locale === 'en'
                );
                const clickThroughBtn2 = buttons.filter(
                    (button) =>
                        button.key === 'click_through_btn_2' &&
                        button.locale === 'en'
                );

                if (buyNowButtons?.length > 0) {
                    buyNowText = buyNowButtons[0].label;
                }
                if (buyInStoreButton?.length > 0) {
                    buyInStoreText = buyInStoreButton[0].label;
                }
                if (clickThroughBtn1?.length > 0) {
                    console.log(clickThroughBtn1[0]);
                    clickThroughBtnOne = clickThroughBtn1[0];
                }
                if (clickThroughBtn2?.length > 0) {
                    clickThroughBtnTwo = clickThroughBtn2[0];
                }
            }

            if (content?.redemption !== null) {
                if (
                    content?.redemption?.method === 2 ||
                    content?.redemption?.method === 3
                ) {
                    isBuyInStore = true;
                } else if (
                    content?.redemption?.method === 1 &&
                    content?.redemption?.url
                ) {
                    let url = new URL(content.redemption.url).search.split('&');
                    let isDownload =
                        url[0].split('?action=').join('') === 'download';
                    showDownload = isDownload;
                } else {
                    isBuyInStore = false;
                }
            } else {
                isBuyInStore = false;
            }

            if (content?.end_at === null || content?.end_at === undefined) {
                end = 'Never';
            } else {
                let endAt = moment(content?.end_at);
                end = endAt.isBefore(moment()) ? exp : endAt.from(moment());
            }

            // Set redemption URL
            let redemptionURL =
                content?.redemption !== null &&
                content?.redemption?.url
                    ? content?.redemption.url
                    : '';

            // Appends forward params (i.e. macros) based on env setting
            if (
                redemptionURL !== '' &&
                process.env.REACT_APP_FORWARD_PARAMS === 'true'
            ) {
                redemptionURL += redemptionURL.indexOf('?') > -1 ? '&' : '?';
                redemptionURL += forwardParams;
            }
            const c = {
                id: content?.id,
                hero: getCdnPath(content?.images?.hero?.url),
                title: content?.display_name,
                brand: content?.brand,
                description: content?.description,
                buyOnline: redemptionURL,
                contentTermId: termID || '',
                contentTerms: tandc,
                endDate: end,
                buyInStore: isBuyInStore,
                showBuyInStore: false,
                toggleTerms: false,
                type: content?.type,
                showContent: true,
                content: content,
                applePass: content?.apple_pass_enabled,
                showDownload: showDownload,
                buyNowText: buyNowText,
                buyInStoreText: buyInStoreText,
                clickThroughBtnOne: clickThroughBtnOne,
                clickThroughBtnTwo: clickThroughBtnTwo,
                linkedAssets: content?.linked_assets,
            };
            dispatch(setContentItem(c));
            if (termID && termID !== null) {
                getContentTerms(termID, device);
            }
            if (content?.android_pass_enabled) {
                postAndroidPass(content?.id, device);
            } else {
                setLoading(false);
            }
        },
        [dispatch, forwardParams, getContentTerms, postAndroidPass, setLoading]
    );

    const catchContent = useCallback(        
        (res, device) => {

            console.log('catching content...');
            try {
                if (res?.data) {
                    setDeliveredContent(res.data);
                    dispatch(setContentResponse(res.data[deliveredContentCursor]));
                    const contentTypes = ['offer', 'prize', 'url', 'message', 'video', 'Sweepstake'];
                    if (contentTypes.includes(res.data[deliveredContentCursor].type)) {
                        if (res.data[deliveredContentCursor].type === 'url' && res.data[deliveredContentCursor].url && res.data[deliveredContentCursor].url !== 'https://internal:next-content') {
                            const parsedContentUrl = new URL(res.data[deliveredContentCursor].url);
                            if (parsedContentUrl.searchParams.has('a8_redirect')) {
                                if (Number(parsedContentUrl.searchParams.get('a8_redirect')) === 1) {
                                    updateContentStatus(res.data[deliveredContentCursor], 1, device);
                                    onRedirectUrl(res.data[deliveredContentCursor].url);
                                    return;
                                }
                            }
                        }
                        checkScratcher(res.data[deliveredContentCursor]);
                        onSetContentItem(res.data[deliveredContentCursor], device);
                    } else {
                        setShowError({
                            showError: true,
                            errorCode: 400,
                        });
                        setLoading(false);
                    }
                } else {
                    setShowError({
                        showError: true,
                        errorCode: res.status,
                    });
                    setLoading(false);
                }
            } catch (err) {
                console.error('Error: ', err);
                if (err.message) {
                    setShowError({
                        showError: true,
                        errorCode: err.status,
                    });
                    setLoading(false);
                } else {
                    setShowError({
                        showError: true,
                        errorCode: 400,
                    });
                    setLoading(false);
                }
            }
        },
        [
            checkScratcher,
            dispatch,
            onSetContentItem,
            setLoading,
            setShowError,
            setDeliveredContent,
            deliveredContentCursor
        ]
    );

    const catchContentByTriggerType = useCallback(
        async (
            triggerable_type,
            triggerable_id,
            client_id,
            device
        ) => {
            try {
                !loading && setLoading(true);
                const res = await axios.post(
                    `${triggerable_type}/${triggerable_id}/catch?client_id=${client_id}`,
                    {},
                    {
                        headers: {
                            'x-device-uuid': `${device?.uuid}`,
                        },
                    }
                );
                catchContent(res, device);
            } catch (err) {
                console.log('err catching content ', err);
            }
        },
        [catchContent, loading, setLoading]
    );

    const catchContentByTriggerUuid = useCallback(
        async (trigger_uuid, device, payload = null) => {
            try {
                !loading && setLoading(true);
                const res = await axios.post(
                    `content/deliver?trigger_uuid=${trigger_uuid}`,
                    payload,
                    {
                        headers: {
                            'x-device-uuid': `${device?.uuid}`,
                        },
                    }
                );
                catchContent(res, device);

            } catch (err) {
                console.log('err catching content ', err);
            }
        },
        [catchContent, loading, setLoading]
    );

    const getTimestampTargets = useCallback(
        async(trigger_uuid) => {
            console.log('********* Requesting timestamps ******** ');

            const res = await axios.get(
                `trigger/timestamps?uuid=${trigger_uuid}`,
                [],
                {
                    headers: {
                        'x-device-uuid': `${device?.uuid}`,
                    },
                }
            );

            if(res && res.data) {
                console.log('========= Retrieved timestamps =======');
                const targetTimestamps = res.data;
                for(let item of targetTimestamps) {
                    if(item.value > timestamp) {
                        console.log('    will ping in ' + (item.value - timestamp) + ' seconds');

                        setTimeout(() => {
                                const payload = {timestamp : (item.value + 1)};
                                catchContentByTriggerUuid(trigger_uuid, device.deviceDetails, payload);
                        }, (item.value - timestamp) * 1000);
                            
                    }
                } 

            }
        },[timestamp, device, catchContentByTriggerUuid]);
    

    useEffect(() => {
        // Check if content has already been delivered. This is needed for multiple content delivery
        if(deliveredContent) {
            return;
        }

        const getTriggerId = (device) => {
            console.log('getting trigger id ...');
            console.log('has slug? ' + hasSlug);
            console.log('location search: ' + location.search);
            if(!hasSlug) {
                window.location.href = '/error?code=400';
            } else if (hasSlug !== null && device?.id) {
                let paramsString = hasSlug ? catchUrlSearch : location.search;
                // console.log('Params string: ' + paramsString);
                const params = new URLSearchParams(paramsString);
                if (
                    params.has('triggerable_id') &&
                    params.has('client_id') &&
                    params.has('triggerable_type')
                ) {
                    let triggerable_id = params.get('triggerable_id');
                    let triggerable_type = params.get('triggerable_type');
                    let client_id = params.get('client_id');
                    if (
                        triggerable_type &&
                        triggerable_type !== null &&
                        triggerable_id &&
                        triggerable_id !== null &&
                        client_id &&
                        client_id !== null
                    ) {
                        catchContentByTriggerType(
                            triggerable_type,
                            triggerable_id,
                            client_id,
                            device
                        );
                    }
                } else if (params.has('trigger_uuid')) {
                    const trigger_uuid = params.get('trigger_uuid');
                    setTriggerUuid(trigger_uuid);
                    let payload = (timestamp) ? {timestamp: timestamp} : null;
                    catchContentByTriggerUuid(trigger_uuid, device, payload);
                    if(timestamp) {
                        getTimestampTargets(trigger_uuid);
                    }                    
                } else {
                    console.log('Missing params...');
                }
            } 
        };
        device?.deviceDetails?.id && getTriggerId(device?.deviceDetails);
    }, [
        catchContentByTriggerType,
        catchContentByTriggerUuid,
        catchUrlSearch,
        device?.deviceDetails,
        device?.deviceDetails?.id,
        hasSlug,
        location.search,
        timestamp,
        getTimestampTargets
    ]);
    
    const moveToNextContent = () => {        
        setDeliveredContentCursor((prevDeliveredContentCoursor) => prevDeliveredContentCoursor + 1);
        onSetContentItem(deliveredContent[deliveredContentCursor + 1], device);
    };

    const handleClickThrough = () => {
        console.log(deliveredContent[deliveredContentCursor]);
        if(deliveredContentCursor < deliveredContent.length) {
            moveToNextContent();
        }
    }

    return (
        <div style={{height: "inherit"}}>
            {loading ||
            showScratcherOverlay === null ||
            !content?.id ||
            content?.id === null ? (
                <Loader showLogo={true}/>
            ) : (
                <div>
                    {showActv8 ? (
                        <div>
                            <div className='LogoContainer'>
                                <img
                                    className='Actv8'
                                    src={actv8Logo}
                                    alt='actv8_logo'
                                />
                                <div>
                                    <Button
                                        onClick={() => setShowActv8(true)}
                                        btnText={'Go Back To Offer'} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                        
                        <ContentDetails
                            open={true}
                            onNoThanks={() => setShowActv8(false)}
                            scratcher={showScratcherOverlay}
                            scratcherOverlayImage={scratcherOverlayImage}
                            forwardParams={forwardParams}
                            content={deliveredContent[deliveredContentCursor]}
                            onClickThrough={handleClickThrough} 
                            triggerUuid={triggerUuid}
                            moveToNextContent={(deliveredContent.length > deliveredContentCursor) && moveToNextContent}
                            nextContent={(deliveredContent.length > deliveredContentCursor) && deliveredContent[deliveredContentCursor + 1]}
                        />

                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Content;